import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { 
  Box,
  Button,
  DialogContent, 
  DialogTitle,
} from '@mui/material';
import store from '../../store';
import PucTemplateSelector from '../puc-template-selector';
import { Puc } from '../../models/puc';
import { getCabinetConfiguration, getCabinetsByTag } from '../../utilities/api-utils';

interface AddPucDialogProps {
  setDialog(arg: boolean): void,
  finish(arg: Puc, side: string): void,
  selectMainPuc: boolean,
}

function AddPucDialog({ setDialog, finish, selectMainPuc }: AddPucDialogProps) {
  const [selectedPuc, setSelectedPuc] = useState<Puc>();
  const [addOnPucTemplates, setAddOnPucTemplates] = useState<Puc[]>([]);
  
  const getCabinetTemplates = async () => {
    const tempAddons = [];
    const cloudKey = store.getState().authorization.cloudKey;
    
    const tag = selectMainPuc ? 'puc_tool_template_full' : 'puc_tool_template_addon';

    const addonCabs = await getCabinetsByTag(cloudKey, tag);
    for (const cab of addonCabs.data) {
      const cabConfig = await getCabinetConfiguration(cloudKey, cab.id);
      if (cabConfig.data.pucs[0]) {
        const newPuc = Puc.fromObject(cabConfig.data.pucs[0]);
        tempAddons.push(newPuc);
      }
    }
    setAddOnPucTemplates(tempAddons);
  };

  useEffect(() => {
    setAddOnPucTemplates([]);
    const asyncGetCabs = async() => {
      await getCabinetTemplates();
    };

    asyncGetCabs();
  }, []);

  const addPuc = (puc: Puc) => {
    if (puc.screens.length > 0) {
      puc.screens = [];
    }
    setSelectedPuc(puc);
  };

  return (
    <Box height='100%'>
      <DialogTitle
        display='flex'
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          height: '100px',
          width: '100%'
        }}>
        <div style={{
            fontWeight: '500',
            color: '#121F35',
            fontSize: '30px'
          }}>
          Add PUC Addon
        </div>
        <Button 
          sx={{
            borderRadius: '5px',
            width: 'auto',
            height: 'auto',
            padding: '0',
            minWidth: '0',
            '&:hover': {
              opacity: '.5',
            }
          }}
          onClick={() => {
            setDialog(false);
          }}>
          <CloseIcon
            sx={{
              padding: '0',
              fontSize: '2rem',
              color: '#121F35',
              width: '40px',
              height: '40px',
            }} />
        </Button>
      </DialogTitle>
      <DialogContent
        sx={{
          height: '700px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <div>
          <PucTemplateSelector pucTemplates={addOnPucTemplates} onPucSelected={addPuc} />
        </div>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            variant='contained'
            onClick={() => setDialog(false)}
            sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <div>
            <Button
              variant='contained'
              onClick={() => finish(selectedPuc!, 'left')}
              sx={{ mr: 1 }}>
              ADD LEFT
            </Button>
            <Button
              variant='contained'
              onClick={() => finish(selectedPuc!, 'right')}
              sx={{ mr: 1 }}>
              ADD RIGHT
            </Button>
          </div>
        </Box>
      </DialogContent>
    </Box>
  );
}

export default AddPucDialog;
